import { RootState } from 'store/rootReducer';

export const IconFooterContentSelector = (state: RootState) => state.content.iconFooter;
